__webpack_require__.p = "/static/manager-studio/";